//
import Model from '@/models/Model'

//
export default class AMassiveEditOffer extends Model {
  static post(data) {
    return this.$http.request({
      method: 'post',
      url: process.env.VUE_APP_API_ROUTE.concat('/massive_create_offer'),
      data,
    })
  }
  resource() {
    return 'massive_create_offer'
  }
}